import { render, staticRenderFns } from "./RecuperationDivV2.vue?vue&type=template&id=23d781cd&"
import script from "./RecuperationDivV2.vue?vue&type=script&lang=ts&"
export * from "./RecuperationDivV2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports